import { Box, Typography } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';

const fontFamily = '"Inter", sans-serif';

const ProposalViewAirflow = ({ airflows = [] }) => {
  if (!airflows || airflows.length === 0) return null;

  // Sort by orderIndex
  const sortedAirflows = [...airflows].sort((a, b) => a.orderIndex - b.orderIndex);

  return (
    <Box className="print-section" sx={{ mb: 4, px: 2 }}>
      {/* Main Header */}
      <Box sx={{ display: 'inline-block', mb: 0 }}>
        <Box
          sx={{
            backgroundColor: '#0d3c61',
            color: '#fff',
            px: 2,
            py: 0.75,
          }}
        >
          <Typography
            sx={{
              fontFamily,
              fontWeight: 600,
              fontSize: 14,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            Airflow
          </Typography>
        </Box>
      </Box>

      {/* Airflow Items */}
      {sortedAirflows.map((item, idx) => (
        <Box
          key={item.id || idx}
          className="airflow-item"
          sx={{
            display: 'flex',
            backgroundColor: '#f8f9fa',
            borderRadius: 1,
            overflow: 'hidden',
            mb: idx < sortedAirflows.length - 1 ? 2 : 0,
            p: 2,
            "@media print": { breakInside: "avoid", pageBreakInside: "avoid" },
          }}
        >
          {/* Image Container - Square */}
          <Box
            sx={{
              width: 130,
              height: 130,
              minWidth: 130,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: '#fff',
              borderRadius: 1,
              mr: 2,
              flexShrink: 0,
            }}
          >
            {item.imageUrl ? (
              <Box
                component="img"
                src={item.imageUrl}
                alt={item.name}
                sx={{
                  maxWidth: '90%',
                  maxHeight: '90%',
                  objectFit: 'contain',
                }}
              />
            ) : (
              <Box sx={{ textAlign: 'center', color: '#ccc' }}>
                <ImageIcon sx={{ fontSize: 48 }} />
              </Box>
            )}
          </Box>

          {/* Content - Rest of space */}
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Typography
              sx={{
                fontFamily,
                fontSize: 14,
                fontWeight: 600,
                color: '#0d3c61',
                mb: 1,
              }}
            >
              {item.name}
            </Typography>
            {item.description && (
              <Typography
                sx={{
                  fontFamily,
                  fontSize: 13,
                  color: '#333',
                  lineHeight: 1.6,
                  whiteSpace: 'pre-wrap',
                }}
              >
                {item.description}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default ProposalViewAirflow;
